import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";

import { useSharedData } from '../Contexts/SharedContext';
import { useTheme } from '../Contexts/ThemeContext';
import { useLanguage } from '../Contexts/LanguageContext';

import { getTranslatedValue } from '../Utils/getTranslatedText';

import Row from '../Components/Layout/Row';
import Wrapper from '../Components/Layout/Wrapper';

import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import PageHeader from '../Components/PageHeader';
import MaskImage from '../Components/MaskImage';
import Readmore from '../Components/Readmore';
import Labels from '../Components/Labels';
import AudioGuideButton from '../Components/AudioGuideButton';

import { Image } from '../Elements/Image';
import { Heading } from '../Elements/Heading';
import { Paragraph } from '../Elements/Paragraph';

const ExhibitionPage = () => {
    const { slug } = useParams();
    const { setTheme } = useTheme();
    const { language } = useLanguage();
    const { content, loading, error } = useSharedData();

    const data = content?.exhibitions?.[slug] ?? null;
    const currentTheme = data?.theme ?? null;

    const headerTitle = getTranslatedValue(data?.header?.title, language);
    const headerPreTitle = getTranslatedValue(data?.header?.preTitle, language);

    const labels = data?.labels?.items;

    const footerTitle = getTranslatedValue(data?.footer?.title, language);
    const footerText = getTranslatedValue(data?.footer?.text, language);
    const footerImage = data?.footer?.image ?? null;
    const audioGuideUrl = data?.audioguide?.audioguideUrl ?? null;

    useEffect(() => {
        if (currentTheme) {
            setTheme(currentTheme);
        }
    }, [currentTheme, setTheme]);

    if (!data) {
        // do something sensible here
    }

    return (
        <>
            <Header withBackNavigation />
                <div className="exhibition-page">
                    <PageHeader 
                        title={headerTitle}
                        preTitle={headerPreTitle}
                        allCapsTitle 
                        withLessMargin
                    />
                    <MaskImage image={ data?.header?.image || null } />
                    <Readmore 
                        visibleText={ getTranslatedValue(data?.readmore?.visibleText, language) }
                        currentSlug={ slug }
                        language={ language }
                    />
                    { labels ? (
                        <Row marginDown={false}>
                            <Labels items={ labels } />
                        </Row>
                    ) : null }
                    <AudioGuideButton audioguideUrl={audioGuideUrl} language={language} />
                    <Row size="medium">
                        { footerTitle ? (
                            <Heading 
                                level={2} 
                                size="medium" 
                                text={ footerTitle} 
                            />
                        ) : null}
                        { footerText ? (
                            <Paragraph 
                                text={ footerText }
                                withMarginTop
                            />
                        ) : null}
                    </Row>
                    { footerImage ? (
                        <Row>
                            <Wrapper>
                                <Image 
                                    src={ footerImage.url }
                                    alt={ footerImage.altText || '' }
                                    srcSet={ footerImage.srcSet }
                                    sizes="100vw"
                                />
                            </Wrapper>
                        </Row>
                    ) : null }
                </div>
            <Footer />
        </>
    );
}

export default ExhibitionPage;